<template>
    <section class="subsequent-activies mb-2">
        <h2 class="text-center mb-4 mt-5">{{ title }}</h2>
        <div class="container">
            <div class="row">
                <activities-inside
                    v-if="activitiesInsideList.length > 0"
                    :activities="activitiesInsideList"
                ></activities-inside>
                <activities-outside
                    v-if="activitiesOutsideList.length > 0"
                    :activities="activitiesOutsideList"
                ></activities-outside>
            </div>
        </div>
    </section>
</template>

<script>
import activitiesInside from '@/components/blocks/activities-inside';
import activitiesOutside from '@/components/blocks/activities-outside';

export default {
    components: {
        activitiesInside,
        activitiesOutside
    },
    props: {
        activitiesInsideList: {
            type: Array,
            default() {
                return [];
            }
        },
        activitiesOutsideList: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: String,
            default: 'Ook interessant'
        }
    }
};
</script>

<style lang="scss">
.subsequent-cards h3 {
    font-size: 1.5rem;
}

@include media-breakpoint-up(lg) {
    .subsequent-activies .subsequent-cards:first-child .card:last-child::after {
        content: '';
        border-right: 1px solid $gray-3;
        height: 90%;
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
        right: -15px;
    }
}
</style>
